<template class="container-background">
  <v-container fluid style="background-color: var(--v-background);">
    <v-row no-gutters>
      <v-col
          v-for="appConfiguration in appConfigurations"
          :key="appConfiguration.key"
          cols="12"
          lg="6"

      >
        <config-field :app-configuration="appConfiguration" :editing="editing" :enabled="getFieldEnabled(appConfiguration)" v-on:startEdit="startEdit" v-on:valueChanged="onFieldValueChanged" />
      </v-col>
    </v-row>
    <v-row no-gutters class="text-center" v-show="appConfigurations.length > 0 && editing">
      <v-col>
        <v-btn @click="cancelEdit" depressed class="mr-2">Cancelar</v-btn>
        <v-btn @click="save" depressed color="rgb(84,79,105)" style="color: var(--v-background)">Salvar</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {getAppConfigurations, getAppConfigurationValuesByAppCode, saveAppConfigurations } from '../../common/securityserver';
import {mapMutations} from "vuex";
import ConfigField from "@/view/config-app/appConfigurationField";
import XippAuthService from "@/services/auth/XippAuthService";
import { isFieldEnabled, isDependentFieldUnfilled, onParentChange } from './dependencyUtils';

export default {
  name: "configFinancialGroup",
  components: {ConfigField},
  data: () => ({
    token: "",
    entityID: "",
    entityType: "",
    appConfigurations: [],
    editing: false,
    appCode: null,
  }),
  computed: {
    valuesByFieldId() {
      const map = {};
      this.appConfigurations.forEach(config => {
        map[config.idAppConfigField] = config.value;
      });
      return map;
    }
  },
  methods: {
    ...mapMutations(["showmsg", "loading"]),
    getFieldEnabled(config) {
      return isFieldEnabled(config, this.valuesByFieldId);
    },
    onFieldValueChanged() {
      onParentChange(this.appConfigurations);
    },
    save(){
      this.loading(true);
      const invalidFields = this.appConfigurations.filter(
        config => isDependentFieldUnfilled(config, this.valuesByFieldId)
      );
      if (invalidFields.length > 0) {
        const names = invalidFields.map(f => f.title).join(', ');
        this.loading(false);
        this.showmsg({ text: `Os seguintes campos precisam ser preenchidos: ${names}`, type: "error" });
        return;
      }
      for(const appConfiguration of this.appConfigurations){
        if(appConfiguration.fieldType == "COMBO"){
          appConfiguration.value = appConfiguration.value.join(",");
        }
      }
      saveAppConfigurations(this.appConfigurations, this.token)
          .then((response) =>{

            for(const appConfiguration of response.data){
              if(appConfiguration.fieldType == 'COMBO' || appConfiguration.fieldType == 'SELECT' ){
                appConfiguration.options = appConfiguration.optionValues ? appConfiguration.optionValues.split(",") : [];
              }
              if(appConfiguration.fieldType == 'COMBO'){
                appConfiguration.value = appConfiguration.value ? appConfiguration.value.split(",") : [];
              }
            }

            this.appConfigurations = response.data;
            this.showmsg({ text: "As configurações foram salvas!", type: "success" });
          })
          .catch((error) => {
            this.showmsg({ text: "Erro ao salvar configurações!", type: "error" });
          })
          .finally(() => {
            this.loading(false);
            this.editing = false
          })

    },
    cancelEdit(){
      this.loadConfigurations();
      this.editing = false
    },
    startEdit(){
      this.editing = true
    },
    loadConfigurations(){
      this.loading(true);
      this.appConfigurations = []
      if(this.entityType && this.entityType == 'APP') {
        getAppConfigurationValuesByAppCode(this.appCode, this.entityType, this.token)
            .then((response) => {
              this.appConfigurations = response.data;
            })
            .catch((error) => {
              this.showmsg({ text: "Erro ao carregar configurações!", type: "error" });
            }).finally(() => {
              this.loading(false);
            })
      } else {
        getAppConfigurations(this.entityID, this.entityType, this.token)
          .then((response) => {
            this.appConfigurations = response.data;
          })
          .catch((error) => {
            this.showmsg({ text: "Erro ao carregar configurações!", type: "error" });
          }).finally(() => {
            this.loading(false);
          })
      }
    },
    async loadJWTToken() {
      if(this.token) {
        localStorage.setItem("LOCALIZED_TOKEN", this.token)
        localStorage.removeItem("SESSION");
        this._xippAuthService = new XippAuthService();
        await this._xippAuthService.GetTokenFull()
          .then((response) => {
              if(response && response.data) {
                  this.token = response.data.token;
                  localStorage.setItem("LOCALIZED_TOKEN", response.data.token)
              }
          }).finally(() => {
              this.loading(false);
          });
      }
    },
  },
  async created() {
    this.entityType = this.$route.meta.entityType;
    const {token, appName, recordId} = this.$route.query;
    this.token = token;
    this.loading(true);
    await this.loadJWTToken();
    this.loading(false);
    this.appCode = appName;
    this.entityID = recordId;
    this.loadConfigurations();
  },

}
</script>

<style scoped>

</style>
